'use client'

import { List } from 'lucide-react'
import { FC } from 'react'

export type WideAgendaButtonProps = {
  /** 「2 / 3」「全3件」（formatAgendaPosition） */
  position: string
  onClick: () => void
  /** true なら自分では左上に置かず、親の並び（「← 前の動画へ」と横並び）に入る */
  inline?: boolean
}

/**
 * 動画の左上に出す「目次」ボタン。たたんだ目次を開き直す・狭い画面で目次を開く。
 * 公開画面のプレイヤーと、管理画面の目次の編集で同じものを使う。
 */
const WideAgendaButton: FC<WideAgendaButtonProps> = ({ position, onClick, inline = false }) => (
  <button
    type="button"
    data-testid="wide-agenda-button"
    onClick={onClick}
    style={{
      ...(inline ? { flexShrink: 0 } : { position: 'absolute', top: '12px', left: '12px', zIndex: 26 }),
      display: 'inline-flex',
      alignItems: 'center',
      gap: '6px',
      padding: '7px 12px',
      border: '1px solid rgba(255,255,255,0.25)',
      borderRadius: '999px',
      background: 'rgba(8,18,38,0.78)',
      color: '#fff',
      fontSize: '12px',
      fontWeight: 700,
      cursor: 'pointer',
      backdropFilter: 'blur(8px)',
    }}
  >
    <List size={14} />
    目次
    <span style={{ opacity: 0.75, fontVariantNumeric: 'tabular-nums' }}>{position}</span>
  </button>
)

export default WideAgendaButton
